import { apiService } from "../apiService";
import loginURLConfig from "../../config/login/loginURLConfig";

export const getServerKey = (callback: CallableFunction) => {
  apiService(
    {
      url: loginURLConfig.getServerKey,
      method: "GET",
      authType: "SPK",
    },
    callback
  );
};
